// Copyright (c) 2024 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet } from 'react-native';

import { Text, View } from './Themed';
import { useUser } from '@/app/user-context';
import { useI18n } from '@/i18n';
import appColors from '@/theme/colors';

export function UserBadge({ debug }: { debug?: boolean }) {
  const { user } = useUser();
  const { t } = useI18n();

  if (!debug) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.label}>{t('auth.debugLabel')}</Text>
      {user ? (
        <Text style={styles.value}>
          {user.forename} ({user.id})
        </Text>
      ) : (
        <Text style={styles.value}>{t('auth.debugNone')}</Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 8,
  },
  label: {
    fontSize: 12,
    color: appColors.neutral.grey,
    marginBottom: 4,
  },
  value: {
    fontSize: 16,
    fontWeight: '600',
  },
});
